Object.defineProperty(exports, '__esModule', { value: true });

var coreComponentsShared = require('../../../../shared');

var useDeprecatedBadge = function () {
    var transformDeprecatedBadge = function (unsafeBadge) {
        switch (unsafeBadge) {
            case 'negative':
                return 'negative-cross';
            case 'positive':
                return 'positive-checkmark';
            case 'attention':
                return 'attention-alert';
            default:
                return coreComponentsShared.exhaustiveCheck(unsafeBadge);
        }
    };
    return {
        transformDeprecatedBadge: transformDeprecatedBadge,
    };
};

exports.useDeprecatedBadge = useDeprecatedBadge;
